export default "__VITE_ASSET__CSmeKwHJ__"